"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullSupportedFormulaEngines = exports.SupportedFormulaEngines = void 0;
// TODO: deprecate below engine once each formula-driven attribute has been
// migrated over to below "FullSupportedFormulaEngines"
var SupportedFormulaEngines;
(function (SupportedFormulaEngines) {
    SupportedFormulaEngines["HyperFormula1"] = "hyperFormula1";
})(SupportedFormulaEngines || (exports.SupportedFormulaEngines = SupportedFormulaEngines = {}));
// Since not rolling out ExcelEngine to all potential candidates, creating separate
// type to help alleviate migration efforts by supporting both flows
var FullSupportedFormulaEngines;
(function (FullSupportedFormulaEngines) {
    FullSupportedFormulaEngines["HyperFormula1"] = "hyperFormula1";
    FullSupportedFormulaEngines["ExcelEngine1"] = "excelEngine1";
})(FullSupportedFormulaEngines || (exports.FullSupportedFormulaEngines = FullSupportedFormulaEngines = {}));
//# sourceMappingURL=FormulaEngine.js.map